import moment from 'moment';
import 'moment/locale/pl';
import {Accordion, AccordionTab} from 'primereact/accordion';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import {ActionButton} from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import CustomDialog from '../components/CustomDialog';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import InputFileChooseComponent from '../components/inputs/InputFileChooseComponent';
import InputTextareaComponent from '../components/inputs/InputTextareaComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import ContactService from '../services/ContactService';
import {saveAs} from 'file-saver';

class ContactContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new ContactService();
        const profile = this.authService.getProfile();
        this.state = {
            element: {
                attachment: undefined,
                title: '',
                content: '',
            },
            questionsList: [],
            showDialog: false,
            saleRepName: this.toTitleCase(profile.agreementSaleRepName),
            saleRepEmail: profile.agreementSaleRepEmail ? profile.agreementSaleRepEmail : '',
            saleRepPhoneNumber: profile.agreementSaleRepPhoneNumber ? profile.agreementSaleRepPhoneNumber : '',
            isWholesale:
                profile.agreementSapRole === 'HURT' || profile.agreementSapRole === 'FRANCZYZA' || profile.agreementSapRole === 'HURT EPT',
        };
        this.downloadMessageAttachment = this.downloadMessageAttachment.bind(this);
    }

    toTitleCase(str) {
        return str
            ? str
                  .toLowerCase()
                  .split(' ')
                  .map((el) => el.charAt(0).toUpperCase() + el.substring(1))
                  .join(' ')
            : str;
    }

    getCleanElement() {
        this.setState({
            element: {
                attachment: undefined,
                title: '',
                content: '',
            },
        });
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.updateQuestionsList();
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleValidForm() {
        const {t} = this.props;
        this.service
            .newContactMessage(this.state.element)
            .then(() => {
                this.getCleanElement();
                this.setState({showDialog: false});
                this.updateQuestionsList();
            })
            .catch(() => {
                this.showErrorMessage(t('contact.newMessageError'));
                this.unblockUi();
            });
    }

    updateQuestionsList() {
        const {t} = this.props;
        this.service
            .getMessages()
            .then((res) =>
                this.setState(
                    {
                        questionsList: res.content,
                    },
                    this.unblockUi()
                )
            )
            .catch(() => {
                this.showErrorMessage(t('contact.errorList'));
                this.unblockUi();
            });
    }

    renderDialog() {
        const {t} = this.props;
        return (
            <div className='row'>
                <InputTextComponent
                    id='title'
                    name='title'
                    label={t('contact.messageTopic')}
                    colClass='col-md-12'
                    value={this.state.element.title}
                    validator={this.validator}
                    validators='required|max:50'
                    onChange={this.handleChange}
                    viewMode='NEW'
                />
                <InputTextareaComponent
                    id='content'
                    name='content'
                    label={t('contact.messageContent')}
                    colClass='col-md-12'
                    value={this.state.element.content}
                    validator={this.validator}
                    validators='required|max:500'
                    onChange={this.handleChange}
                    viewMode='NEW'
                    autoResize
                />
                <div className='col-12'>
                    <div className='row file-row'>
                        <InputFileChooseComponent
                            id='attachment'
                            name='attachment'
                            colClass='col-width-auto'
                            multiple={false}
                            file={this.state.element.attachment}
                            showLabel={false}
                            viewMode='NEW'
                            label='Załącz plik'
                            onChange={this.handleChange}
                            validator={this.validator}
                            itemLabel='fileName'
                            maxFileSize={10000000}
                            maxFileCount={1}
                            validateViewMode
                            validators='not_required'
                            browseButton={
                                !this.state.element.attachment ? (
                                    <div className='attachment-label'>
                                        <img
                                            alt={t('contact.attachmentLabel')}
                                            src='/images/ico_contact_attachment.svg'
                                            className='attachment-label-icon'
                                        />
                                        <div className='attachment-label-text'>{t('contact.attachmentLabel')}</div>
                                    </div>
                                ) : null
                            }
                            dragNdrop={false}
                        />
                        <div className='button-col'>
                            <ActionButton
                                label={t('contact.sendMessage')}
                                handleClick={(e) => {
                                    e.preventDefault();
                                    this.handleFormSubmit(e);
                                }}
                                variant='blue'
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {t} = this.props;
        return (
            <DivContainer colClass='container-fluid'>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <CustomDialog
                        name='message-dialog'
                        className='contact-dialog'
                        visible={this.state.showDialog}
                        viewMode={this.props.viewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                            })
                        }
                        onHide={() => {
                            this.getCleanElement();
                            this.setState({showDialog: false});
                        }}
                        modal
                        header={<label>{t('contact.writeMessage')}</label>}
                    >
                        {this.renderDialog()}
                    </CustomDialog>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                    <DivContainer colClass='dashboard contact'>{this.renderDetails()}</DivContainer>
                </BlockUi>
            </DivContainer>
        );
    }

    downloadMessageAttachment(messageId, fileName) {
        const {t} = this.props;
        this.service
            .downloadMessageAttachment(messageId, fileName)
            .then((response) => {
                saveAs(response, fileName);
                // return response.blob();
            })
            .catch((err) => {
                this.showErrorMessage(t('contact.errorAttachment'));
            });
    }

    renderDetails() {
        const {t} = this.props;
        const {questionsList} = this.state;
        return (
            <React.Fragment>
                <div className='header-dialog-button-container'>
                    <ActionButton
                        label={t('contact.writeMessage')}
                        variant='button blue new-message-button'
                        handleClick={(e) => {
                            e.preventDefault();
                            this.setState({showDialog: true});
                        }}
                    />
                </div>
                <div className='p-card'>
                    <div className='p-card-content'>
                        <div className='header'>
                            <img src='/images/ico_cards_wallet.svg' alt={`${t('contact.wallet')}`} />
                            {t('contact.accountManager')}
                        </div>
                        <div className='row content'>
                            <InputTextComponent
                                id='person'
                                name='person'
                                label={t('contact.person')}
                                colClass='col-lg-4 col-md-6 col-sm-12'
                                value={this.state.saleRepName}
                                viewMode={'VIEW'}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                            />
                            <InputTextComponent
                                id='email'
                                name='email'
                                label={t('contact.email')}
                                colClass='col-lg-4 col-md-6 col-sm-12'
                                value={this.state.saleRepEmail}
                                viewMode={'VIEW'}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                            />
                            <InputTextComponent
                                id='contactPhone'
                                name='contactPhone'
                                label={t('contact.contactPhone')}
                                colClass='col-lg-4 col-md-6 col-sm-12'
                                value={this.state.saleRepPhoneNumber}
                                viewMode={'VIEW'}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
                <Accordion activeIndex={[]} multiple>
                    {questionsList !== undefined && questionsList.length > 0
                        ? questionsList.map((conversation) => {
                              return (
                                  <AccordionTab
                                      key={`conversation-${conversation.id}`}
                                      header={
                                          <div>
                                              <div className='accordion-tab-header-label'>
                                                  {moment(conversation.date).locale('pl').format('D MMMM YYYY')}
                                              </div>
                                              <div className='accordion-tab-header-title'>
                                                  <div>{conversation.title}</div>
                                              </div>
                                          </div>
                                      }
                                      headerClassName='border'
                                  >
                                      <div className='col-12'>
                                          <div className='row'>{conversation.content}</div>
                                          <DivContainer
                                              colClass='row file-row'
                                              rendered={conversation.fileName !== undefined && conversation.fileName !== null}
                                          >
                                              <ActionLink
                                                  variant='accent'
                                                  label={conversation.fileName}
                                                  handleClick={(e) => {
                                                      e.preventDefault();
                                                      this.downloadMessageAttachment(conversation.id, conversation.fileName);
                                                  }}
                                                  key={`${conversation.id}-download-button`}
                                                  className='p-link file'
                                                  iconName='mdi-file'
                                                  iconColor='accent'
                                                  iconSize='xs'
                                                  iconSide='left'
                                                  downloadFile
                                              />
                                          </DivContainer>
                                      </div>
                                  </AccordionTab>
                              );
                          })
                        : null}
                </Accordion>
            </React.Fragment>
        );
    }
}

ContactContainer.defaultProps = {};

ContactContainer.propTypes = {};

export default withTranslation()(ContactContainer);
